import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserDataService } from 'src/app/core/services/user-data.service';
import { CustomerPortal } from '../../secured-skeleton/models/customer-portal';
import { ThemeService } from 'src/app/core/services/theme.service';

declare var hbspt: any;

@Component({
  selector: 'cross-selling',
  templateUrl: './cross-selling.component.html',
  styleUrls: ['./cross-selling.component.scss'],
  standalone: false,
})
export class CrossSellingComponent implements OnInit {
  // Stores info about the portal trying to be accessed
  portal: CustomerPortal;

  constructor(
    private route: ActivatedRoute,
    private userDataService: UserDataService,
    private themeService: ThemeService,
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.portal = this.userDataService.portals.filter((portal) => portal.addonName === params['addon'])[0];

      //This is the HubSpot form embed script. Check this for more info:https://legacydocs.hubspot.com/docs/methods/forms/advanced_form_options
      hbspt.forms.create({
        region: 'na1',
        portalId: '14519504',
        formId: this.portal.formId,
        target: `#${this.portal.target}`,
        cssClass: 'cross-selling-form',
        onFormReady: () => {
          this.changeTheme();
        },
      });
    });

    this.themeService.themeSubject$.subscribe((theme) => {
      this.changeTheme(theme);
    });

    this.themeService.systemPreferenceQuery.addEventListener('change', async (event) => {
      this.changeTheme('auto');
    });
  }

  async changeTheme(theme?: 'auto' | 'light' | 'dark' | undefined) {
    const currentTheme = theme ?? (await this.themeService.getTheme());

    let darkMode = false;

    if (currentTheme === 'auto') {
      darkMode = this.themeService.systemPreferenceQuery.matches;
    } else if (currentTheme === 'dark') {
      darkMode = true;
    }

    const iframe: HTMLCollectionOf<HTMLIFrameElement> | null = document.getElementsByClassName(
      `hs-form-iframe`,
    ) as HTMLCollectionOf<HTMLIFrameElement>;

    if (iframe[0]) {
      // Get the iframe's document
      const iframeDocument: Document = iframe[0]?.contentDocument || iframe[0].contentWindow?.document;

      if (iframeDocument) {
        // Modify CSS styles
        const cssRules: string = darkMode
          ? `
          span { color: white; } 

          input, select, textarea{
            color: white;
          }
          
          textarea:focus, input:focus {
              color: white;
          }

          .hs-input{
            color: white;
          }
          `
          : `
          span { color: #33475b; } 

          input, select, textarea{
            color: #33475b;
          }
          
          textarea:focus, input:focus {
              color: #33475b;
          }

          .hs-input{
            color: #33475b;
          }
          `;
        const styleElement: HTMLStyleElement = iframeDocument.createElement('style');
        styleElement.type = 'text/css';
        styleElement.appendChild(iframeDocument.createTextNode(cssRules));

        // Append the style element to the head of the iframe's document
        iframeDocument.head.appendChild(styleElement);
      }
    }
  }
}
